var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFactCounter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_36891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4201 11.0481C14.0829 11.0481 16.2415 8.8895 16.2415 6.2267C16.2415 3.5639 14.0829 1.40527 11.4201 1.40527C8.75726 1.40527 6.59863 3.5639 6.59863 6.2267C6.59863 8.8895 8.75726 11.0481 11.4201 11.0481Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3488 27.1194H1.77734V23.9052C1.7944 22.2719 2.22515 20.6695 3.02936 19.2478C3.83356 17.8261 4.98499 16.6315 6.37608 15.7754C7.76716 14.9194 9.35253 14.4299 10.9841 14.3526C12.6157 14.2754 14.2402 14.6129 15.7059 15.3337",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2061 16.4053V29.2624",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7773 22.834H29.6345",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_36891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.706055 0.333984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFactCounter2);
export default __webpack_public_path__ + "static/media/icon-fact-counter-2.764f28fa521961e3bc68282f7325a88b.svg";
export { ForwardRef as ReactComponent };